import React from 'react';
import {
  StepHeaderContainer,
  StepHeaderCodeText,
  StepHeaderNoCodeText,
  StepHeaderTitle,
} from 'src/styles/signup/signupSteps';

interface StepHeaderProps {
  title: string;
  description?: string | React.ReactElement;
  code?: boolean;
}

const StepHeader: React.FC<StepHeaderProps> = ({ title, description, code }) => {
  const HeaderStepDescription = code ? StepHeaderCodeText : StepHeaderNoCodeText;

  return (
    <StepHeaderContainer>
      <StepHeaderTitle>{title}</StepHeaderTitle>
      <HeaderStepDescription>{description}</HeaderStepDescription>
    </StepHeaderContainer>
  );
};

export default StepHeader;
